import type { Airport } from '@libs/trip-planner-interfaces';
import { IngredientType } from '@libs/trip-planner-interfaces';

import type { TransportIngredientFilters } from './transportIngredient';
import { TransportIngredient } from './transportIngredient';

export interface FlightIngredientFilters extends TransportIngredientFilters {
  maxNumberOfStops?: number;
}

export class FlightIngredient extends TransportIngredient<IngredientType.Flight> {
  public static get defaultFilters(): FlightIngredientFilters {
    return {
      ...TransportIngredient.defaultFilters,
      maxNumberOfStops: undefined,
    };
  }

  public filters: FlightIngredientFilters = FlightIngredient.defaultFilters;

  constructor() {
    super(IngredientType.Flight);
  }

  public setDepartureAirport(airPort: Airport): void {
    this.fromPort = airPort.iata;
    this.fromPortText = airPort.name;
    this.fromPortDisplayText = airPort.displayingText;
    this.transportIds = [];
  }

  public setArrivalAirport(airPort: Airport): void {
    this.toPort = airPort.iata;
    this.toPortText = airPort.name;
    this.toPortDisplayText = airPort.displayingText;
    this.transportIds = [];
  }

  public resetFlightIngredientFilters(): void {
    this.transportIds = [];

    this.filters = FlightIngredient.defaultFilters;
  }
}
